// extracted by mini-css-extract-plugin
export default {"container":"Banner_container__ireow","title":"Banner_title__cWjh4","image":"Banner_image__UhcGT","description":"Banner_description__tgFFs"};